import * as React from 'react';
import ToggleButton from '@material-ui/lab/ToggleButton';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { SectionFieldContainerProps, SectionFieldOption } from '../typings';
import { globalColors } from '../styles/globalColorVariables';

const useStyles = makeStyles(() =>
  createStyles({
    toggleButton: {
      marginTop: '0.5rem !important'
    },
    toggleContainer: {
      display: 'grid',
      gap: '8px',
      gridTemplateColumns: 'repeat(auto-fill, minmax(calc(93% / 3), 1fr))'
    },
    selectedToggleButton: {
      backgroundColor: `${globalColors.primaryColor} !important`,
      color: 'white !important'
    }
  })
);

const Toggle: React.FC<SectionFieldContainerProps> = (toggleProps) => {
  const classes = useStyles();
  const { sectionFieldDetails } = toggleProps;
  const [selected, setSelected] = React.useState(Array(sectionFieldDetails.selectOptions?.length).fill(false));
  const updateToggle = (value: boolean, index: number) => () => {
    const selectedCopy = [];
    selectedCopy[index] = value;
    setSelected(selectedCopy);
  };
  return (
    <div>
      <Typography variant='body1' color='primary'>
        {sectionFieldDetails.name}
        {sectionFieldDetails.isMandatory && <span>*</span>}
      </Typography>
      <div className={classes.toggleContainer}>
        {sectionFieldDetails.selectOptions?.map((eachOption: SectionFieldOption, i: number) => (
          <ToggleButton
            classes={{ root: classes.toggleButton, selected: classes.selectedToggleButton }}
            key={eachOption.rank}
            value={eachOption.name}
            selected={selected[i]}
            onChange={updateToggle(!selected[i], i)}
          >
            {eachOption.name}
          </ToggleButton>
        ))}
      </div>
    </div>
  );
};

export default Toggle;
